import { PageComponentaContext } from "widgets/interfaces"
import { injectPageComponentaContext } from "widgets/commonComponents/base/injectPageComponentaContext"
import * as classNames from "classnames"
import { getImgAlt, getImgTitle, getNewlinkTargetProperties, isAriaHidden } from "widgets/widgetsUtils"
import {  secondsToMinutes } from "../../../../siteWidgets/siteWidgetUtils";
import * as apiUrls from "config/apiUrls"
import { DateDisplay } from "../../../../commonComponents/inline/dateDisplay/dateDisplay";
import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";

import { IFieldDisplayData } from "../../../../commonDataObjects/interfaces";

interface AudioHeadlinesItemSlotProps {
    item: any
    isMobileWeb?: boolean
    fieldsDisplaySettings: IFieldDisplayData
}

@injectPageComponentaContext()
export class AudioHeadlinesAutoItemSlot extends React.Component<AudioHeadlinesItemSlotProps & Partial<PageComponentaContext>, {}>{

    render() {
        const { item,  fieldsDisplaySettings, isMobileWeb } = this.props;
        if (!item) return null;
        else{
            const { title, subTitle, promotionImageDetails, publishedLink } = item;
            const audioArticleData = item.specialData && item.specialData.audioData;
            return (
                <HyperLinkBuilder href={publishedLink} linkTarget={getNewlinkTargetProperties()} className={classNames("slotView", { "emptySlot": subTitle.length === 0 && title.length === 0 })}>

                    <div className="mediaArea">
                        <img src={apiUrls.getImageUrl(promotionImageDetails, { w:  200 , h: 112 })} alt={getImgAlt(promotionImageDetails)} title={getImgTitle(promotionImageDetails)} aria-hidden={isAriaHidden(promotionImageDetails)} /> 
                {!isMobileWeb && <img className={"bepoAudioIcon"} style={{display: audioArticleData ? "block" : "none"}} src={"//ynet.co.il/Common/images/bepo/play_btn_bepo.png"} />}

                    </div>
    
                    <div className="textArea">
                          <div className="moreDetails">
                           <div className="duration">{audioArticleData && audioArticleData.durationSeconds && secondsToMinutes(audioArticleData.durationSeconds, "דק'")}</div> 
                            {fieldsDisplaySettings.isDateVisible && <DateDisplay date={item.dateUpdatedOnSite} />}
                            </div>  
                         
                         {fieldsDisplaySettings.isTitleVisible &&
                            <div className="slotTitle">
                                {title}
                            </div>}
                        

                    </div>
                </HyperLinkBuilder>
            )
        }
   
    }
}